import classNames from 'classnames'

export const FormGroup = ({children, field, form, hint, groupClass, labelClass, ...props }) => {
  const error = fieldError({field, form})

  return <div className={classNames('form-group', { 'form-group-invalid': !!fieldError({field, form}) }, groupClass)}>
    <label className={classNames('control-label', labelClass)} htmlFor={field.name}>{props.label}  {props.required && <abbr title={I18n.t('misc.required_field')}>*</abbr>}</label>
    {children || <input id={field.name} className='form-control' type='text' {...field} {...props} />}
    {error && <span className='help-inline'>{error}</span>}
    {hint && <small className='form-text text-muted'>{hint}</small>}
  </div>
}

const fieldError = ({field, form}) =>
  form.touched[field.name] && form.errors[field.name]
